import { useState } from "react";

/** element that can expand to show more content */
export function Expando(props: {
  readonly label: string | JSX.Element,   /** text to always show */
  readonly expanded?: boolean,    /** default: false */
  readonly children: string | JSX.Element, /** content to show when expanded */
}) {
  const [expanded, setExpanded] = useState(props.expanded ?? false);
  const [id] = useState(Math.random().toString());

  return (<span>
    <span className="expando">
      <input type="checkbox" id={id} onChange={(e) => setExpanded(e.target.checked)} />
      <label className="expando" htmlFor={id}>{props.label}</label>
    </span>
    {expanded && props.children !== '' ? <><br />{props.children}</> : undefined}
  </span>);
}
